import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

import { PopupTheme } from '../enums';

export const useTransferPopupAnalytics = (currentTheme: PopupTheme) => {
  const trackPopupShown = (eventParameter: string | null) => {
    TrackingApi.trackTransferPopupAction({
      theme: PopupTheme[currentTheme].toLowerCase(),
      operation: 'show',
      eventParameter,
      screen: getScreenOrientationWithSizes(),
    });
  };

  const trackPopupClick = () => {
    TrackingApi.trackTransferPopupAction({
      theme: PopupTheme[currentTheme].toLowerCase(),
      operation: 'click',
      screen: getScreenOrientationWithSizes(),
    });
  };

  const trackPopupClose = () => {
    TrackingApi.trackTransferPopupAction({
      theme: PopupTheme[currentTheme].toLowerCase(),
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    });
  };

  return {
    trackPopupShown,
    trackPopupClick,
    trackPopupClose,
  };
};
